import { MigrationSpec } from "../migration.models"

const metaAdsFlowNodeTemplates: MigrationSpec = {
  type: "SEED_META_ADS_FLOW_NODE_TEMPLATES",
  collection: "FlowNodeTemplate",
  risk: "SAFE",
  title: {
    en: "Meta Ads → FlowBot node template",
    tr: "Meta Ads → FlowBot node şablonu"
  },
  description: {
    en:
      "Inserts the “Meta conversion event” FlowBot node template (`type: meta_conversion_event`) " +
      "when it is missing, keyed by `type`. Written with `$setOnInsert`, so a second run changes " +
      "nothing and an existing (possibly edited) template is never overwritten.",
    tr:
      "“Meta conversion event” FlowBot node şablonunu (`type: meta_conversion_event`) yoksa " +
      "ekler; anahtar `type`. `$setOnInsert` ile yazılır: ikinci çalıştırma hiçbir şey değiştirmez, " +
      "mevcut (düzenlenmiş olabilecek) şablonun üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: { type: { $in: ["meta_conversion_event"] } },
    count: 1
  },
  notes: [
    {
      en: "Until this runs, the Meta conversion event node cannot be added to a flow in the builder.",
      tr: "Bu çalışana kadar Meta conversion event node'u flow builder'da bir akışa eklenemez."
    }
  ]
}

export default metaAdsFlowNodeTemplates
